var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { selectCoopProjects } from "../../../balancingSelectors/selectBalancingCoopProjects";
import { selectCoopInfo, selectCoopSelectedProjectTypeId } from "../../../selectors/selectCoopInfo";
import { selectCoopProjectInfo } from "../../../selectors/selectCoopProjectInfo";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../../utils/utilNumber";
import { GridContainer } from "../../generic/grid-layout/GridContainer";
import { actionCoopProjectDifficultySelected, actionCoopProjectSelected, actionCoopProjectTypeInfoRequest, } from "../actionCoop";
import { GridItemCoopProject } from "./GridItemCoopProject";
var MasterViewCoopProjectsDOM = /** @class */ (function (_super) {
    __extends(MasterViewCoopProjectsDOM, _super);
    function MasterViewCoopProjectsDOM(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelect = function (index) {
            var projects = selectCoopProjects();
            if (projects) {
                var _a = _this.props, onSelectProject = _a.onSelectProject, activeProject = _a.activeProject;
                var project = projects[index];
                if (project) {
                    var difficultyLevel = activeProject && activeProject.typeId === project.id && activeProject.difficulty
                        ? activeProject.difficulty
                        : 1;
                    onSelectProject(project, difficultyLevel);
                }
            }
        };
        props.onLoad(props.coopInfo.id, props.playerId);
        return _this;
    }
    MasterViewCoopProjectsDOM.prototype.render = function () {
        var _a = this.props, activeProject = _a.activeProject, selectedProjectTypeId = _a.selectedProjectTypeId, level = _a.coopInfo.level;
        var projects = selectCoopProjects();
        var selectedProjectTypeIndex = 0;
        if (projects && projects.length > 0) {
            if (selectedProjectTypeId > -1 || (activeProject && activeProject.projectId)) {
                var visibleProjectTypeId_1 = selectedProjectTypeId > -1 ? selectedProjectTypeId : activeProject.typeId;
                selectedProjectTypeIndex = projects.findIndex(function (project) { return project.id === visibleProjectTypeId_1; });
            }
        }
        // TODO: Move ICoopProjectTypeWithTooltip to a separate interface file and same for everywhere
        var data = (projects || []).map(function (project) {
            var isLocked = project.requCoopLevel > level;
            var locaKey = project.requCoopLevel && isLocked
                ? IdLoca.floatingText_requCoopLevel
                : project.locakey;
            var replacementText = project.requCoopLevel
                ? utilNumber.format(project.requCoopLevel)
                : "";
            var replacements = new Map([
                [ReplacementLoca.zero_0, replacementText],
            ]);
            return __assign({}, project, { locaKey: locaKey,
                replacements: replacements });
        }, []);
        return (React.createElement("div", { className: "build-menu__master-view" },
            React.createElement(GridContainer, { items: data || [], gridItemRenderer: GridItemCoopProject, onSelect: this.onSelect, selectedIndex: selectedProjectTypeIndex })));
    };
    return MasterViewCoopProjectsDOM;
}(React.Component));
var mapState = function (state) { return ({
    activeProject: selectCoopProjectInfo(state),
    coopInfo: selectCoopInfo(state),
    playerId: selectPlayerInfo(state).playerId,
    selectedProjectTypeId: selectCoopSelectedProjectTypeId(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onLoad: function (coopId, playerId) {
        if (coopId && playerId) {
            dispatch(actionCoopProjectTypeInfoRequest(coopId, playerId));
        }
    },
    onSelectProject: function (project, difficultyLevel) {
        dispatch(actionCoopProjectSelected(project.id));
        dispatch(actionCoopProjectDifficultySelected(difficultyLevel));
    },
}); };
export var MasterViewCoopProjects = connect(mapState, mapDispatch)(MasterViewCoopProjectsDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/MasterViewCoopProjects.tsx
// module id = 2598
// module chunks = 3